import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authService from '../../services/authService';
import '../../assets/styles/auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-form-section">
          <Link to="/" className="auth-logo">
            <i className="fas fa-shield-alt"></i>
            <span>SafeWork<span className="brand-360">360</span></span>
          </Link>

          {success ? (
            <>
              <div className="auth-alert success">
                <i className="fas fa-check-circle"></i>
                <div>
                  <strong>Check your email</strong>
                  <p style={{ margin: '0.25rem 0 0' }}>
                    We've sent password reset instructions to {email}
                  </p>
                </div>
              </div>

              <div className="auth-header">
                <h1>Email sent!</h1>
                <p>
                  Click the link in your email to reset your password. 
                  If you don't see it, check your spam folder.
                </p>
              </div>

              <div className="auth-form">
                <button 
                  type="button" 
                  className="btn-auth-primary"
                  onClick={() => { setSuccess(false); setEmail(''); }}
                >
                  <i className="fas fa-redo"></i>
                  Try a different email
                </button>
              </div>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-back">
                <i className="fas fa-arrow-left"></i>
                Back to sign in
              </Link>

              <div className="auth-header">
                <h1>Reset your password</h1>
                <p>Enter your email address and we'll send you a link to reset your password.</p>
              </div>

              {error && (
                <div className="auth-alert error">
                  <i className="fas fa-exclamation-circle"></i>
                  <span>{error}</span>
                </div>
              )}

              <form className="auth-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Email address</label>
                  <div className="input-icon-wrapper">
                    <i className="fas fa-envelope input-icon"></i>
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      placeholder="name@company.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      autoFocus
                    />
                  </div>
                </div>

                <button type="submit" className="btn-auth-primary" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm"></span>
                      Sending...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane"></i>
                      Send reset link
                    </>
                  )}
                </button>
              </form>
            </>
          )}

          <div className="auth-footer">
            Remember your password? <Link to="/login">Sign in</Link>
          </div>
        </div>

        {/* Features Section */}
        <div className="auth-features-section">
          <div className="features-content">
            <h2>Secure password recovery</h2>
            <p>We take security seriously. Your password reset link will expire in 1 hour for your protection.</p>
            
            <div className="feature-list">
              <div className="feature-item">
                <div className="feature-item-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <div className="feature-item-text">
                  <h4>Secure Reset</h4>
                  <p>One-time use links that expire after 1 hour</p>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-item-icon">
                  <i className="fas fa-lock"></i>
                </div>
                <div className="feature-item-text">
                  <h4>Encrypted Data</h4>
                  <p>All data is encrypted in transit and at rest</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
